export default __webpack_public_path__ + "static/media/Kaiserpinguin.dd10f698.jpg";